import { MiniKit, Permission } from '@worldcoin/minikit-js';

import React, { Suspense, useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import Future from './pages/future';
import Orders from './pages/orders';
import { RootLayout } from './pages/root-layout';
import { useAutoLogin } from './store/auth';
import MarketPage from './pages/market';

const requestPermission = async () => {
    if (!MiniKit.isInstalled()) {
        return;
    }
    const input = { permission: Permission.Notifications };

    await MiniKit.commandsAsync.requestPermission(input);
};

function App() {
    useAutoLogin();

    useEffect(() => {
        setTimeout(() => {
            requestPermission();
        }, 3000);
    }, []);

    return (
        <Suspense fallback={<p></p>}>
            <Routes>
                <Route element={<RootLayout />} path="/">
                    <Route index element={<Navigate to="/future" replace />} />
                    <Route path="/market" element={<MarketPage />} />
                    <Route path="/future" element={<Future />} />
                    <Route path="/orders" element={<Orders />} />

                    <Route
                        path="*"
                        element={<Navigate to={'/market'} replace />}
                    />
                </Route>
            </Routes>
        </Suspense>
    );
}

export default App;
